export default __webpack_public_path__ + "static/media/PCISDSS.b6257fc7.svg";